import IsHydrated from "helpers/IsHydrated";
import Image from "next/legacy/image";
import Link from "next/link";
import HideIf from "util/HideIf";
import { dateToYMD } from "util/date-helper";
import { getRelativeImagePath } from "../../../util/helper/getRelativeImagePath";
import PAImage from "../images/PAImage";
import PAText, { FONT_SIZE } from "../typography/PAText/PAText";
import styles from "./style.module.scss";

function ArticleCard({
  articleUrl,
  imageUrl,
  dateOfPublish,
  title,
  description,
  isDate = false,
  alt,
}: any) {
  const imageAlt = `Expert Tips and Advice on ${title}`;

  return (
    <div className="d-flex flex-column">

      <Link href={articleUrl} prefetch={false} className={styles.link} title={alt}>

        <HideIf show={isDate}>

          <Image
            src={getRelativeImagePath(`/cms/${imageUrl}`)}
            alt={imageAlt}
            title={imageAlt}
            unoptimized
            width={290}
            height={180}
            style={{ objectFit: "cover" }}
          />
        </HideIf>
        <HideIf show={!isDate}>

          <PAImage
            width={240}
            height={240}
            src={getRelativeImagePath(`/cms/${imageUrl}`) || "https://partsavatar.ca/images/home/sample-img.png"}
            alt={title}
          />
        </HideIf>
        <div className={`d-fex flex-column ${styles.textData}`}>
          <IsHydrated>
            <HideIf show={isDate}>
              <PAText
                component="span"
                className="text-left m-t-10 m-b-10"
                color="light-grey"
                style={{ lineHeight: "1.4" }}
                fontSize={FONT_SIZE[0]}
                inlineBlock
              >
                {dateToYMD(new Date(dateOfPublish), true)}
              </PAText>
            </HideIf>
          </IsHydrated>

          <PAText
            component="h3"
            fontSize={FONT_SIZE[2]}
            className="text-left"
            color="black"
            style={{ marginTop: "0", minHeight: 35 }}
          >
            {title}

          </PAText>

          <PAText
            component="p"
            color="light-grey"
            style={{ lineHeight: "1.4" }}
            fontSize={FONT_SIZE[0]}
          >
            {description}

          </PAText>

        </div>

      </Link>
    </div>
  );
}

export default ArticleCard;
